import { Routes } from '@angular/router';
import { DefaultLayoutComponent } from './layout';
//import { AuthGuard } from './services/auth.gaurd';
//import { NonAuthGuard } from './services/non-auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./views/pages/home-page/home-page.component').then(m => m.HomePageComponent),
    data: {
      title: 'Home'
    }
  },
  {
    path: 'home-page',
    redirectTo: '',
    pathMatch: 'full'
  },
  {
    path: 'page404',
    loadComponent: () => import('./views/pages/page404/page404.component').then(m => m.Page404Component),
    data: {
      title: 'Page 404'
    }
  },
  
  // Registration flow routes with NonAuthGuard
  {
    path: 'customer-first-details',
    loadComponent: () => import('./views/pages/customer-first-details/customer-first-details.component').then(m => m.CustomerFirstDetailsComponent),
    //canActivate: [NonAuthGuard],
    data: {
      title: 'Customer Details'
    }
  },

  {
    path: 'customer-details',
    loadComponent: () => import('./views/pages/customer-details/customer-details.component').then(m => m.CustomerDetailsComponent),
    //canActivate: [NonAuthGuard],
    data: {
      title: 'Customer Details'
    }
  },

  {
    path: 'customer-emp',
    loadComponent: () => import('./views/pages/customer-emp/customer-emp.component').then(m => m.CustomerEmpComponent),
    //canActivate: [NonAuthGuard],
    data: {
      title: 'Customer Employee'
    }
  },
  
  {
    path: 'customers-profile',
    loadComponent: () => import('./views/pages/customers-profile/customers-profile.component').then(m => m.CustomersProfileComponent),
    //canActivate: [NonAuthGuard],
    data: {
      title: 'Customer Employee'
    }
  },
  
  // Public routes - no guard needed
  {
    path: 'common-footer',
    loadComponent: () => import('./views/common/common-footer/common-footer.component').then(m => m.CommonFooterComponent),
    data: { title: 'Common Footer' }
  },

  {
    path: 'thank-you',
    loadComponent: () => import('./views/pages/thank-you/thank-you.component').then(m => m.ThankYouComponent),
    data: { title: 'Thank You' }
  },

  { path: '**', redirectTo: '' }
];